import "react-toastify/dist/ReactToastify.min.css";
import "./App.less";

import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { Slide, ToastContainer, toast } from "react-toastify";
import { Login, PrivateRoute } from "./utils/Routes";
import { basename, to } from "./utils/Url";

import { Layout } from "antd";
import { ReactQueryDevtools } from "react-query/devtools";
import { Container } from "semantic-ui-react";
import { EmployeePositionTasks } from "./employee_tasks/components/EmployeeTasks";
import { Theming } from "./Providers/ThemeProvider";
import { StartPage } from "./StartPage";
import { AreaRoutes } from "./areas/Routes";
import { SankhyaSideMenu } from "./common/components/SankhyaSideMenu";
import { TopHeader } from "./common/components/TopHeader";
import { TopMenu } from "./common/components/TopMenu";
import { EmployeeRoutes } from "./employees/Routes";
import { PendencyList } from "./pendencies/components/PendencyList";
import { PositionRoutes } from "./positions/Routes";
import { GlobalStyle } from "./styled-component/GlobalStyle";
import { AuthProvider } from "./utils/Auth";
import { useSettingValue } from "./utils/Hooks";
import { useEnableSankhyaMenu } from "./utils/useEnableSankhyaMenu";
import moment from "moment";
import "moment/dist/locale/pt-br";
import { setupInjections } from "./injections";

setupInjections();

moment.defaultFormat = "DD/MMM/YYYY";
moment.locale("pt-br");

const queryClient = new QueryClient();
function AppContent() {
  // TODO check these routes behaviour properly
  const authDomain = useSettingValue("REACT_APP_AUTH_DOMAIN");
  const sideMenuEnabled = useSettingValue("SHOULD_SHOW_SIDE_MENU");
  const { enableSankhyaMenu } = useEnableSankhyaMenu(authDomain);
  return (
    <Theming>
      <GlobalStyle />
      <BrowserRouter basename={basename}>
        <AuthProvider>
          <Switch>
            <PrivateRoute
              path={"/tmcard/employee_position_tasks/:employee_uuid"}
            >
              <EmployeePositionTasks />
            </PrivateRoute>
            <Route path="/login" component={Login} />
            <Route>
              <ToastContainer
                position={toast.POSITION.BOTTOM_RIGHT}
                transition={Slide}
              />
              <Layout>
                <SankhyaSideMenu />
                <Layout
                  style={{
                    paddingLeft: sideMenuEnabled && enableSankhyaMenu ? 64 : 0,
                  }}
                >
                  <TopHeader />
                  <TopMenu />
                  <Container style={{ marginTop: "4rem" }}>
                    <Switch>
                      <PrivateRoute path={"/minha_equipe"}>
                        <StartPage />
                      </PrivateRoute>
                      <PrivateRoute path={"/areas"}>
                        <AreaRoutes />
                      </PrivateRoute>
                      <PrivateRoute path={"/cargos"}>
                        <PositionRoutes />
                      </PrivateRoute>
                      <PrivateRoute path={"/funcionarios"}>
                        <EmployeeRoutes />
                      </PrivateRoute>
                      <PrivateRoute path={"/pendencias"}>
                        <PendencyList />
                      </PrivateRoute>
                      <Redirect to={"/minha_equipe"} />
                    </Switch>
                  </Container>
                </Layout>
              </Layout>
            </Route>

            <Route
              path="/:url*"
              exact
              strict
              render={(props) => {
                window.location.href = to(`${props.location.pathname}/`);
              }}
            />
          </Switch>
        </AuthProvider>
      </BrowserRouter>
    </Theming>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContent />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
